import { useState, useRef, useEffect, useCallback } from 'react'
import { ipdPatients } from '../constants'
import { emptyString } from '../../Radiology/Constants/constants'
import { IpdMappedPatients } from '../../lms/utils'
import { allocation, tableHeadText } from '../modals'
import { Dialog, DialogContent, IconButton } from '@mui/material'
import UploadDocs from '../../patients/dashboard/UploadDocs'
import uploadIcon from '../../../assets/images/download_uplaod.webp'
import patientDashboardIcon from './../../../assets/images/patientDashboardIcon.webp'
import { selectPatientFhirId, setQueryParam } from './IpdVisitSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { useLocation, useNavigate } from 'react-router-dom'
import '../bms.scss'
import { setBedPatientDetails } from '../../ipRegistration/IpdPatientRegisterSlice'
import { getBedAssignmentRecordByPatientIdAndStatus } from '../../../services/IPDService'
import { BED_IPD_DASHBOARD_URL } from '../endpoints/EndPoints'

const IpdVisitPatientTable = ({ registeredId }: any) => {
  const patientFhirId = useAppSelector(selectPatientFhirId)
  const dispatch = useAppDispatch()
  const [bedPatientList, setBedpatient] = useState<ipdPatients[]>([])
  const VisitTableRef = useRef<HTMLDivElement | null>(null)
  const location = useLocation()
  const locationParams = new URLSearchParams(location?.search)
  const id = patientFhirId
    ? patientFhirId
    : registeredId
    ? registeredId
    : locationParams?.get('regId')

  const navigate = useNavigate()
  const dateObject = (dateString: string) => {
    const dateObject = new Date(dateString)
    return dateObject.toISOString().split('T')[0]
  }

  const [isOpenDocsPage, setIsOpenDocsPage] = useState(false)
  const [selectedPatientId, setSelectedPatientId] = useState<string>('')

  const handleDocClick = (patientId: string) => {
    setIsOpenDocsPage(true)
    setSelectedPatientId(patientId)
  }
  const handleCloseDialog = () => {
    setIsOpenDocsPage(false)
  }
  const differenceInDays = (d1: string, d2: any) => {
    const presentDate = new Date()
    const admittedDate = new Date(d1)
    const dischargedDate = new Date(d2)
    if (d2) {
      const DifferenceInTime = dischargedDate.getTime() - admittedDate.getTime()
      const DifferenceInDays = Math.round(DifferenceInTime / (1000 * 3600 * 24))
      return DifferenceInDays
    } else {
      const DifferenceInTime = presentDate.getTime() - admittedDate.getTime()
      const DifferenceInDays = Math.round(DifferenceInTime / (1000 * 3600 * 24))
      return DifferenceInDays
    }
  }
  const filteredPatient = useCallback(async () => {
    const response = await getBedAssignmentRecordByPatientIdAndStatus(
      id,
      allocation?.assigned
    )
    if (response?.success) {
      const res = response?.data?.bed_patient_assignment_map
      const mapped = await IpdMappedPatients(res)
      dispatch(setBedPatientDetails(mapped))
      setBedpatient(mapped)
    } else {
      dispatch(setBedPatientDetails([]))
      setBedpatient([])
    }
  }, [id, dispatch])
  useEffect(() => {
    filteredPatient()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredPatient])

  const handleVisitDashboard = (id: string) => {
    dispatch(setQueryParam({ patientId: id }))
    navigate(
      `${BED_IPD_DASHBOARD_URL}?id=${bedPatientList?.[0]?.patientId}&bedId=${bedPatientList?.[0]?.bedId}&bedStatus=${bedPatientList?.[0]?.bedStatus}`
    )
  }
  return (
    <>
      <div className='sub-container'>
        <div className='bedTableHead' ref={VisitTableRef}>
          <table className='data-table table-fixed admin-table relative w100'>
            <thead className='sticky'>
              <tr>
                <th className='text-center w12'>{tableHeadText.uhid}</th>
                <th className='text-left w15'>{tableHeadText.name}</th>
                <th className='text-center w10'>{tableHeadText.mobileNo}</th>
                <th className='text-center w8'>{tableHeadText.gender}</th>
                <th className='text-center w10'>DOB</th>
                <th className='text-center w10'>{tableHeadText.bedNo}</th>
                <th className='text-center w13'>
                  {tableHeadText.operatingUnit}
                </th>
                <th className='text-center w10'>{tableHeadText.status}</th>
                <th className='text-center w10'>{tableHeadText.admission}</th>
                <th className='text-center w10'>{tableHeadText.discharge}</th>
                <th className='text-center w11'>Days of Adm</th>
                <th className='text-center w11'>
                  {tableHeadText.patientdocuments}
                </th>
                <th className='text-center w11'>{tableHeadText.view}</th>
              </tr>
            </thead>
            <tbody>
              {bedPatientList?.length > 0 ? (
                bedPatientList?.map((d: ipdPatients, i: number) => {
                  return (
                    <tr key={i}>
                      <td className='text-center'>
                        {d?.patientId ? d?.patientId : allocation?.hyphen}
                      </td>
                      <td className='text-left'>{d?.patientName}</td>
                      <td className='text-center'>
                        {d?.patientMobile ?? allocation?.hyphen}
                      </td>
                      <td className='text-center'>
                        {d?.patientGender ?? allocation?.hyphen}
                      </td>
                      <td className='text-center'>
                        {d?.patientAge ?? allocation?.hyphen}
                      </td>
                      <td className='text-center'>
                        {d?.bedNumber ?? emptyString}
                      </td>
                      <td className='text-center'>{d?.location}</td>
                      <td className='text-center'>
                        {d?.bedStatus === allocation?.assigned
                          ? allocation?.admittedList
                          : allocation?.dischargedList}
                      </td>
                      <td className='text-center'>
                        {dateObject(d?.dateCreated)}
                      </td>
                      <td className='text-center'>
                        {d?.dateOfDischarge
                          ? dateObject(d?.dateOfDischarge)
                          : '-'}
                      </td>
                      <td className='text-center'>
                        {differenceInDays(d?.dateCreated, d?.dateOfDischarge)}
                      </td>
                      <td>
                        <div
                          onClick={() =>
                            handleDocClick(d?.patient_registered_id)
                          }
                          className='uploadbtn'
                          style={{ textAlign: 'center' }}
                        >
                          <img
                            title='Upload Document`s'
                            src={uploadIcon}
                            alt='upload button'
                          />
                        </div>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                          {/* <div>
                            <div className='uploadbtn'>
                              <img
                                title='Visits'
                                src={visiticon}
                                alt='Visits'
                                style={{ width: '15px' }}
                              />
                            </div>
                          </div> */}
                          <div>
                            <div className='uploadbtn'>
                              <img
                                title='patient Dashboard'
                                src={patientDashboardIcon}
                                alt='patient Dashboard'
                                onClick={() =>
                                  handleVisitDashboard(d?.patientId)
                                }
                                style={{ width: '18px' }}
                              />
                            </div>
                          </div>
                        </div>
                        <Dialog
                          open={isOpenDocsPage}
                          onClose={handleCloseDialog}
                          maxWidth='sm'
                        >
                          <IconButton
                            onClick={handleCloseDialog}
                            className='flex-end f12 ml-auto'
                          >
                            x
                          </IconButton>
                          <DialogContent className='margin2 padding20'>
                            <UploadDocs
                              patientId={selectedPatientId}
                              muhid={bedPatientList?.[0]?.id}
                            />{' '}
                          </DialogContent>
                        </Dialog>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td className='text-center' colSpan={10}>
                    No Patient Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default IpdVisitPatientTable
